module.exports = __webpack_public_path__ + "img/1_024.8d01a011.jpg";